import { useInfiniteActivatedUsers } from '@/hooks/user/users';
import React, { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import UsersTable from '../UsersTable';
import { TUserActivationToggle, TUserFilterOption } from '@/types/User.types';
import { MIN_CHARS_TO_DO_SEARCH } from '@/constants/numberVars';
import RosterActionsPopover from './RosterActionsPopover';
import { isUndefined } from 'lodash';

interface Props {
  filterOption?: TUserFilterOption;
  filterText: string;
  setIsLoadingSearch: Dispatch<SetStateAction<boolean>>;
}

const ActivatedUsersTable = ({ filterOption, filterText, setIsLoadingSearch }: Props) => {
  const { isLoading, data, refetch, isRefetching, infinitePagination } = useInfiniteActivatedUsers({
    filterOption,
    filterText,
  });

  // old logic for row marking, was used for `invalidatedUserId` in <UsersTable invalidatedUserId={userBeingInteractedWith?.id} ... />
  // const [userBeingInteractedWith, setUserBeingInteractedWith] = useState<TUserActivationToggle>();

  const isSearching = useMemo(
    () => filterOption !== undefined && filterText.length >= MIN_CHARS_TO_DO_SEARCH && isRefetching,
    [filterOption, filterText, isRefetching],
  );

  useEffect(() => {
    setIsLoadingSearch(isSearching);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearching]);

  return (
    <>
      <UsersTable
        users={data}
        // TODO: nemam pagination; pravi posebnu tabelu sa skrol botm ili daj param paginacije getNextPage iz useIntin querija
        // pagination={pagination}
        infinitePagination={infinitePagination}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // invalidatedUserId={userBeingInteractedWith?.id}
        isSearching={isSearching}
        ActionElement={(userToUpdate: TUserActivationToggle) => {
          const isUserOnboarded = !isUndefined(userToUpdate?.user_metadata?.sex);

          return (
            <RosterActionsPopover selectedUser={userToUpdate} isUserOnboarded={isUserOnboarded} refetch={refetch} />
          );
        }}
      />
    </>
  );
};

export default ActivatedUsersTable;
